import { Box } from "@chakra-ui/react";
import type { ReactStoryblokComponent } from "types/storyblok";
import RichtextAdapter from "../RichtextAdapter";
import contentStyles from "./Content.styles";
import type { ContentAdapterProps } from "./Content.d";

const ContentAdapter = ({
  blok: { content, maxWidth, richTextStyles = contentStyles },
  sbEditable,
}: ReactStoryblokComponent<ContentAdapterProps>) => {
  const maxMdWidth = maxWidth ? `${maxWidth}px` : "none";

  return (
    <Box maxWidth={{ base: "none", md: maxMdWidth }} {...sbEditable}>
      <RichtextAdapter content={content} customStyles={richTextStyles} />
    </Box>
  );
};

export default ContentAdapter;
